/* eslint-disable */
import { createContext, useContext, useReducer, useMemo } from "react";
// Auth context
const loadingContext = createContext();
// Setting custom name for the context which is visible on react dev tools
loadingContext.displayName = "Loading Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "LOADING": {
      return { ...state, loading: state.loading + 1 };
    }
    case "UNLOADING": {
      return {
        ...state,
        loading: state.loading - 1 < 0 ? 0 : state.loading - 1,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// context provider
function LoadingContextProvider({ children }) {
  const initialState = {
    loading: 0,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return (
    <loadingContext.Provider value={value}>{children}</loadingContext.Provider>
  );
}

// custom hook for using context
function useLoading() {
  const context = useContext(loadingContext);

  if (!context) {
    throw new Error(
      "useLoading should be used inside the AuthContextProvider."
    );
  }

  return context;
}

// Context module functions

function handleLoading(dispatch, isLoading) {
  if (isLoading) dispatch({ type: "LOADING" });
  else dispatch({ type: "UNLOADING" });
}

export { LoadingContextProvider, useLoading, handleLoading };
